export default __webpack_public_path__ + "static/emblem-47987729ee6a0bebe511f903db18a231.png";